module.exports = __webpack_public_path__ + "static/media/222bgMain.44898717.jpg";